(() => {
  const name = 'campaignExpandableCampaign';

  App.common = App.common || {};

  App.common[name] = (() => {
    let $expandableArea = null;
    let $pageWrapper = null;
    let $expandableContent = null;

    const isOpened = () => !!$expandableArea.attr('data-expandable-area-status');

    const handleScroll = () => {
      if (isOpened()) {
        if (window.scrollY > 120 && isOpened()) {
          App.eventBus.trigger('campaign:expandable-area:close');
        }
      }
    };

    const openExpandableArea = (isUserEvent = false) => {
      $expandableArea.attr('data-expandable-area-status', 'opened');
      // Adding filter: blur to the hero banner when expanding campaign area
      $pageWrapper.addClass('expandable-campaign-area-opened');

      $expandableContent.slideToggle().promise().done(() => {
        $pageWrapper.toggleClass('expandable-campaign-area-opened', true);
      });

      $(document).on('scroll', handleScroll);

      if (isUserEvent) {
        TrackApp.trackInteraction(
          'expandable campaign area',
          'click',
          'expose expandable campaign area',
          'gaEvent',
        );
      }
    };

    const closeExpandableArea = () => {
      $expandableArea.attr('data-expandable-area-status', '');
      $expandableContent.slideToggle().promise().done(() => {
        $pageWrapper.toggleClass('expandable-campaign-area-opened', false);
      });
      $(document).off('scroll', handleScroll);
    };

    const initExpandableArea = () => {
      $expandableContent = $('[data-expandable]', $expandableArea);
      const $toggleExpandable = $('[data-toggle-expandable]', $expandableArea);
      $pageWrapper = $expandableArea.closest('[data-appmodule]');
      const $heroBanner = $('[data-hero-banner]', $pageWrapper);

      $toggleExpandable
        .on('click', (event) => {
          if (isOpened()) {
            closeExpandableArea();
          } else {
            const isUSerEvent = event.pageX && event.pageY;
            openExpandableArea(isUSerEvent);
          }
        });

      $heroBanner.add($expandableContent)
        .on('click', () => {
          if (isOpened()) {
            $toggleExpandable.click();
          }
        });

      // In case we need to close area from another JS file
      App.eventBus.on('campaign:expandable-area:open', openExpandableArea);
      App.eventBus.on('campaign:expandable-area:close', closeExpandableArea);
    };

    const init = () => {
      $expandableArea = $('[data-campaign-expandable-area]');
      if ($expandableArea.length) {
        initExpandableArea($expandableArea);
      }
    };

    return {
      init,
    };
  })();
})();
